import React from 'react';

import { Box } from 'shared';
import { isImage, isVideo } from 'shared_DEPRECATED/components/File/utils';
import Spacer from 'shared_DEPRECATED/components/Spacer/Spacer';
import { Attachment } from 'shared_DEPRECATED/types/Attachment';

import {
  ChatMessageFileAttachment,
  ChatMessageImageAttachment,
} from 'features/chat/components/ChatMessages';
import { ChatMessageAudioAttachment } from 'features/chat/components/ChatMessages/ChatMessageAudioAttachment';
import { ChatMessageVideoAttachment } from 'features/chat/components/ChatMessages/ChatMessageVideoAttachment';
import { UnuploadedAttachment } from 'features/chat/config/types/Attachment';

type ChatMessageAttachmentsProps = {
  attachments: UnuploadedAttachment[] | Attachment[];
  onlyMedia: boolean;
};

export const ChatMessageAttachment = ({
  attachments,
  onlyMedia,
}: ChatMessageAttachmentsProps) => {
  return onlyMedia ? (
    <Box>
      {attachments.map((attachment, index) => {
        const { name, url } = attachment;
        const isLastAttachment =
          attachments.length - 1 === index && attachments.length % 2 !== 0;

        const attachmentKey =
          'attachmentId' in attachment ? attachment.attachmentId : '';
        const processingStatus =
          'processingStatus' in attachment && attachment.processingStatus
            ? attachment.processingStatus
            : null;

        if (isImage(attachment.contentType)) {
          return (
            <React.Fragment key={attachmentKey ?? url}>
              <ChatMessageImageAttachment
                name={name}
                url={url}
                isLastAttachment={isLastAttachment}
                index={index}
                attachmentKey={attachmentKey}
                media={attachments}
                contentType={attachment.contentType}
              />
            </React.Fragment>
          );
        }

        return (
          <React.Fragment key={attachmentKey ?? url}>
            {isVideo(attachment.contentType) ? (
              <ChatMessageVideoAttachment
                url={url}
                isLastAttachment={isLastAttachment}
                index={index}
                attachmentKey={attachmentKey}
                processingStatus={processingStatus}
                media={attachments}
                // @ts-ignore
                previewSrc={attachment.thumbnail?.url}
              />
            ) : (
              <ChatMessageAudioAttachment
                url={url}
                attachmentKey={attachmentKey}
                duration={attachment.duration!}
              />
            )}
          </React.Fragment>
        );
      })}
    </Box>
  ) : (
    <>
      {attachments.map((attachment) => {
        const { name, url, contentType, contentLength } = attachment;
        const attachmentKey =
          'attachmentId' in attachment ? attachment.attachmentId : '';

        return (
          <React.Fragment key={attachmentKey ?? url}>
            <Spacer size="md md zr">
              <ChatMessageFileAttachment
                name={name}
                url={url}
                attachmentKey={attachmentKey}
                contentType={contentType}
                contentLength={contentLength}
              />
            </Spacer>
          </React.Fragment>
        );
      })}
    </>
  );
};
